import { listingSchemaEnhancer } from '@fhnw/components/Blocks/Listing/schema';
import ListTemplate from '@fhnw/components/Blocks/Listing/variations/ListTemplate';
import GridTemplate from '@fhnw/components/Blocks/Listing/variations/GridTemplate';

export const listingBlockVariations = [
  {
    id: 'list',
    title: 'Liste',
    isDefault: false,
    template: ListTemplate,
    schemaEnhancer: listingSchemaEnhancer,
  },
  {
    id: 'grid',
    title: 'Kacheln',
    isDefault: true,
    template: GridTemplate,
    schemaEnhancer: listingSchemaEnhancer,
  },
];
